const { I18n } = window as any

const COLUMN_TYPE_VALUES = [
  'Projects::Columns::System',
  'Projects::Columns::Text',
  'Projects::Columns::Number',
  'Projects::Columns::Date',
  'Projects::Columns::Select',
] as const

export function getColumnTypes() {
  return COLUMN_TYPE_VALUES.map((value) => ({
    value,
    label: I18n.t(
      `project_groups.columns_editor.column_types.${value.split('::').pop()?.toLowerCase()}`
    ),
  }))
}

export function getSystemColumnKeyLabel(key: string): string {
  return I18n.t(`activerecord.attributes.project_ticket.${key}`)
}

/**
 * Calculate contrasting text color (white or black) based on background color luminance.
 * Uses the standard luminance formula: 0.299*R + 0.587*G + 0.114*B
 *
 * NOTE: Keep in sync with Ruby version in:
 * app/helpers/application_helper.rb#contrast_color_for_hex
 */
export function getContrastColor(hexColor: string): string {
  const hex = hexColor.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b
  return luminance > 186 ? '#000000' : '#ffffff'
}
